// 必须作为独立模块最先被 import：ES module 求值顺序是"依赖先于自身"，
// 若把 window.React = React 直接写在 entry.js 里，会晚于它 import 的
// app-main.js 等文件求值（app-main.js 顶层就读了 React），导致 React undefined。
import React from 'react';

window.React = React;
